import { render } from "./sixthSection.vue?vue&type=template&id=f060d22a"
import script from "./sixthSection.vue?vue&type=script&lang=js"
export * from "./sixthSection.vue?vue&type=script&lang=js"

import "./sixthSection.vue?vue&type=style&index=0&id=f060d22a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__